<template>
  <div>
    <header>
      <router-link :to="{name: 'user_home'}" tag="span" class="title">hora</router-link>
      <svg class="logo" width="100%" height="100%" viewBox="0 0 23 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;">
          <g transform="matrix(0.267164,0,0,0.267164,-9.01251,-13.083)">
              <path d="M118.302,91.273L118.302,105.374L76,105.374L76,91.273L104.202,91.273L104.202,77.172L118.302,77.172L118.302,91.273ZM90.137,63.071L90.137,77.172L76.036,77.172L76.036,63.071L61.935,63.071L61.935,105.374L47.835,105.374L47.835,63.071L33.734,63.071L33.734,48.97L118.302,48.97L118.302,63.071L90.137,63.071Z"/>
          </g>
      </svg>

    </header>
    <main>
      <slot id="main"></slot>
    </main>
  </div>
</template>

<script>
export default {
  name: 'hora'
}
</script>


<style lang="sass">
  main
    margin: 4em

    @media print
      margin: 0

    @media screen and (max-width: 768px)
      margin: 2em

    hr
      border: 0
      height: 2px
      background-color: #d8d8d8
      margin: 1em 0

  header
    display: flex
    align-items: center
    padding: 0 0 0.5em
    margin: 4em

    @media screen and (max-width: 768px)
      margin: 2em

    @media print
      margin: 0.5em 0

    svg.logo
      display: inline-block
      height: 2em
      align-self: center
      justify-self: flex-end
      margin-left: auto
      width: auto

    span.title
      text-transform: uppercase
      font-weight: 700
      display: inline-block
      margin: 0
      font-size: 2em
      position: relative

    svg.logo path
      fill: black

    span.title
      color: black

  button, select
    appearance: none
    border: 0
    background: #8d8d8d
    color: white
    font-family: inherit
    text-transform: uppercase
    font-weight: 700
    padding: 1em
    margin: 1em 0
    border-radius: 4px
    display: inline-flex
    flex-grow: 0
    flex-basis: 0
    cursor: pointer

    &:hover
      opacity: 0.75

  .buttons
    display: flex
    justify-content: space-between
    flex-wrap: wrap

  .button-group
    display: flex
    button, select
      margin-right: 1px
      border-radius: 0

      &:first-child
        border-radius: 4px 0 0 4px

      &:last-child
        margin-right: 0
        border-radius: 0 4px 4px 0

  @media print
    .buttons
      display: none
</style>